module.exports = __webpack_public_path__ + "static/media/microchip.69988efe.svg";